import ArticlePage from './ArticlePage';
import { guideArticles } from '@/mocks/articles';

export default function SafetyGuidePage() {
  return <ArticlePage data={guideArticles.safety} />;
}